import SignInSide from "../pages/loginPage/loginPage";
import DashboardPage from "../pages/dashBoard/holeDashboardPage";
import PlanDetails from "../pages/planDetailsPage/planDetails";
import SupportPage from "../pages/supportPage/SupportPage";
import UsersPage from "../pages/usersPage/usersPage";
import DailyTransactions from "../pages/dailyTransactions/DailyTransactions";
// import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from "@mui/material";

// import notFound from "../assets/images/404.svg";
// import { AppContext } from "../Context/AppContext";
// const NotFound = () => (
//   <img src={notFound} alt="error" className="notFounf"></img>
// );
// const theme = createTheme();

// const App = () => {
//   const [limit, setLimit] = useState("");
//   let value = {
//     limit,
//     setLimit,
//   };
//   return (
//     <ThemeProvider theme={theme}>
//       <AppContext.Provider value={value}>
//         <Router>
//           <Routes>
//             <Route path="/" element={<SignInSide />} />
//             <Route path="/sendOtp" element={<SendOtpToMail />} />
//             <Route path="/verifyOtp" element={<VerifyOtpFromMail />} />
//             <Route path="/changePassword" element={<PasswordChangePage />} />
//             <Route path="/Dashboard" element={<DashboardPage />} />
//             <Route path="/Plan details" element={<PlanDetails />} />
//             <Route path="*" element={<NotFound />} />
//           </Routes>
//         </Router>
//       </AppContext.Provider>
//     </ThemeProvider>
//   );
// };

// export default App;
import { Navigate, useRoutes } from "react-router-dom";
import DashboardLayout from "../pages/dashBoard/DashboardLayout";
import Page404 from "../pages/notFoundPage";
import SendOtpToMail from "../pages/forgotPasswordPage/sendOtpToMail";
import VerifyOtpFromMail from "../pages/forgotPasswordPage/verifyOtpFromMail";
import PasswordChangePage from "../pages/forgotPasswordPage/changePassword";

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: "/Dashboard",
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/Dashboard/Home" />, index: true },
        { path: "Home", element: <DashboardPage /> },
        { path: "planDetails", element: <PlanDetails /> },
        { path: "users", element: <UsersPage /> },
        { path: "support", element: <SupportPage /> },
        { path: "dailyTransactions", element: <DailyTransactions /> },
        // { path: "products", element: <CommingSoon /> },
        // { path: "blog", element: <CommingSoon /> },
      ],
    },
    
    {
      path: "/",
      element: <SignInSide />,
    },
    {
      path: "/sendOtp",
      element: <SendOtpToMail />,
    },
    {
      path: "/verifyOtp",
      element: <VerifyOtpFromMail />,
    },
    {
      path: "/changePassword",
      element: <PasswordChangePage />,
    },
    // {
    //   element: <></>,
    //   children: [
    //     { element: <Navigate to="/" />, index: true },
    //     { path: "404", element: <Page404 /> },
    //     { path: "*", element: <Navigate to="/404" /> },
    //   ],
    // },
    {
      path: "*",
      element: <Page404 />,
    },
  ]);
  return routes;
}
